/* unplugin-vue-components disabled */import { render } from "./AgentMakesMoney.vue?vue&type=template&id=3fb71e72&scoped=true"
import script from "./AgentMakesMoney.vue?vue&type=script&lang=js"
export * from "./AgentMakesMoney.vue?vue&type=script&lang=js"

import "./AgentMakesMoney.vue?vue&type=style&index=0&id=3fb71e72&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb71e72"]])

export default __exports__